import {
  get_userInfo
} from "@/api/api.user.js";

const user = {
  namespaced: true,

  state: {
    user: '',
    role: '',
    email: '',
    codice: '',
    menu: [],
    userSwitch: {},
    clienti: [],
    idUtente: 0,
  },

  mutations: {
    SET_USER: (state, user) => {
      state.user = user.Utente
      state.role = user.Tipologia
      state.email = user.EMail
      state.menu = user.Menu
      state.codice = user.Codice
      state.idUtente = user.IdUtente
    },

    SET_USERSWITCH: (state, data) => {
      state.userSwitch = data
    },

    SET_CLIENTI: (state, data) => {
      state.clienti = data
    },
  },

  actions: {

    userInfo({
      commit,
      dispatch
    }) {

      return new Promise((resolve, reject) => {

        get_userInfo().then(resp => {

          commit("SET_USER", resp.data)
          resolve(resp)

        }).catch(err => {

          reject(err)
        })
      })

    },


  },

  getters: {
    getUserSwitch: state => state.userSwitch,
    getClienti: state => state.clienti,
    getMail: state => state.email,
    getRole: state => state.role,
    getCodice: state => state.codice,
    getIdUtente: state => state.idUtente,
  }
}


export default user
